import React from 'react';
import { AskRemiHero } from '../../components/dashboard/AskRemiHero';
import { DashboardStats } from '../../components/dashboard/DashboardStats';
import { PageContainer } from '../../components/common/layout/PageContainer';
import { useLayoutConfig } from '../../hooks/useLayoutConfig';
import { NewDesignIntroModal } from '../../components/dashboard/NewDesignIntroModal';
import { useAskRemiEnabled } from '../../stores/useOrganizationStore';

const DashboardV2: React.FC = () => {
  const { topPadding } = useLayoutConfig();
  const { enabled: askRemiEnabled } = useAskRemiEnabled();

  return (
    <div
      className="dashboard-bg min-h-screen flex flex-col items-center justify-center"
      style={{ paddingTop: topPadding }}
    >
      <NewDesignIntroModal />
      <PageContainer className="space-y-10">
        {askRemiEnabled && <AskRemiHero />}
        <DashboardStats />
      </PageContainer>
    </div>
  );
};

export default DashboardV2;
